(function () {
	const HOST_SEL = '.wp-block-group.is-style-hh-expandable-hero-host';
	const TOGGLE_SEL = '.wp-block-button.is-style-hh-expandable-hero-toggle';
	const OPEN_CLASS = 'hh-expandable-hero-is-open';

	function initAria() {
		document.querySelectorAll(HOST_SEL).forEach((host) => {
			const toggles = host.querySelectorAll(`${TOGGLE_SEL} a, ${TOGGLE_SEL} button`);
			const open = host.classList.contains(OPEN_CLASS);
			toggles.forEach((el) => {
				if (!el.hasAttribute('aria-expanded')) {
					el.setAttribute('aria-expanded', open ? 'true' : 'false');
				}
			});
		});
	}

	document.addEventListener('click', (e) => {
		const interactive = e.target.closest(`${TOGGLE_SEL} a, ${TOGGLE_SEL} button`);
		if (!interactive) {
			return;
		}
		const host = interactive.closest(HOST_SEL);
		if (!host) {
			return;
		}

		if (interactive.tagName === 'A') {
			const hrefAttr = interactive.getAttribute('href');
			if (hrefAttr != null && hrefAttr !== '' && hrefAttr !== '#') {
				return;
			}
			e.preventDefault();
		}

		const open = !host.classList.contains(OPEN_CLASS);
		host.classList.toggle(OPEN_CLASS, open);
		interactive.setAttribute('aria-expanded', open ? 'true' : 'false');
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAria);
	} else {
		initAria();
	}
})();
